// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';

// const NavStrip = () => {
//   const location = useLocation();
//   const currentPath = location.pathname;

//   const navItems = [
//     { to: "/search-doctor",        icon: "fas fa-user-md",              label: "Doctor & Clinics" },
//     { to: "/LabsAndCenters",       icon: "fas fa-flask",                label: "Labs & Centers" },
//     { to: "/HomeAndHealthcare",    icon: "fas fa-hand-holding-heart",   label: "Health Caretaker" },
//     { to: "/PharmacyAndMedicines", icon: "fas fa-capsules",             label: "Pharmacy & Medicines" },
//     { to: "/HealthInsurance",      icon: "fas fa-file-medical",         label: "Health Insurance" },
//     { to: "/doctors-blog",         icon: "fas fa-newspaper",            label: "Read Articles" },
//   ];

//   return (
//     <>
//       <style>{`
//         .c-icon-list {
//           background-color: #046525;
//           height: 70px;
//           padding: 0 40px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           width: 100%;
//         }

//         .c-icon-list__list_wrapper {
//           display: flex;
//           align-items: center;
//           justify-content: space-evenly;
//           width: 100%;
//           max-width: 900px;
//           padding: 0 20px;
//         }

//         .c-icon {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           text-decoration: none !important;
//           color: #ffffff !important;
//           transition: opacity 0.2s;
//           gap: 4px;
//           min-width: 100px;
//           text-align: center;
//         }

//         .c-icon:hover {
//           opacity: 0.8;
//         }

//         /* Active page ka icon disabled dikhega */
//         .c-icon.active-page {
//           opacity: 0.4;
//           cursor: default;
//           pointer-events: none;
//         }

//         .tab-icon {
//           font-size: 18px;
//           color: #ffffff;
//           display: block;
//           line-height: 1;
//         }

//         .c-icon span {
//           font-size: 12px;
//           font-weight: 500;
//           line-height: 1;
//           font-family: 'Lato', sans-serif !important;
//           white-space: nowrap;
//         }

//         .v-bar {
//           width: 1px;
//           height: 35px;
//           background-color: rgba(255, 255, 255, 0.25);
//           flex-shrink: 0;
//         }

//         @media (max-width: 991px) {
//           .c-icon-list {
//             height: auto;
//             padding: 12px 10px;
//           }
//           .c-icon-list__list_wrapper {
//             flex-wrap: wrap;
//             gap: 15px;
//             justify-content: center;
//             padding: 0;
//           }
//           .v-bar { display: none; }
//           .c-icon { min-width: 70px; }
//         }
//       `}</style>

//       <div className="c-icon-list">
//         <div className="c-icon-list__list_wrapper">
//           {navItems.map((item, index) => {
//             const isActive = currentPath === item.to;
//             return (
//               <React.Fragment key={item.to}>
//                 {index > 0 && <div className="v-bar"></div>}
//                 <Link
//                   to={item.to}
//                   className={`c-icon ${isActive ? 'active-page' : ''}`}
//                   onClick={isActive ? (e) => e.preventDefault() : undefined}
//                 >
//                   <i className={`${item.icon} tab-icon`}></i>
//                   <span>{item.label}</span>
//                 </Link>
//               </React.Fragment>
//             );
//           })}
//         </div>
//       </div>
//     </>
//   );
// };

// export default NavStrip;


















import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const NavStrip = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { to: "/search-doctor",        icon: "fas fa-user-md",              label: "Doctor & Clinics" },
    { to: "/LabsAndCenters",       icon: "fas fa-flask",                label: "Labs & Centers" },
    { to: "/HomeAndHealthcare",    icon: "fas fa-hand-holding-heart",   label: "Health Caretaker" },
    { to: "/PharmacyAndMedicines", icon: "fas fa-capsules",             label: "Pharmacy & Medicines" },
    { to: "/HealthInsurance",      icon: "fas fa-file-medical",         label: "Health Insurance" },
    { to: "/doctors-blog",         icon: "fas fa-newspaper",            label: "Read Articles" },
  ];

  const isHomePage = currentPath === "/" || currentPath === "/#/";

  const visibleItems = navItems.filter(item => {
    if (item.to === "/search-doctor" && isHomePage) return false; // ← Homepage par hide
    return currentPath !== item.to; // ← Baaki pages normal
  });

  return (
    <>
      <style>{`
        .c-icon-list {
          background-color: #046525;
          height: 70px;
          padding: 0 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
        }

        .c-icon-list__list_wrapper {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          width: 100%;
          max-width: 900px;
          padding: 0 20px;
        }

        .c-icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-decoration: none !important;
          color: #ffffff !important;
          transition: opacity 0.2s;
          gap: 4px;
          min-width: 100px;
          text-align: center;
        }

        .c-icon:hover {
          opacity: 0.8;
        }

        .tab-icon {
          font-size: 18px;
          color: #ffffff;
          display: block;
          line-height: 1;
        }

        .c-icon span {
          font-size: 12px;
          font-weight: 500;
          line-height: 1;
          font-family: 'Lato', sans-serif !important;
          white-space: nowrap;
        }

        .v-bar {
          width: 1px;
          height: 35px;
          background-color: rgba(255, 255, 255, 0.25);
          flex-shrink: 0;
        }

        @media (max-width: 991px) {
          .c-icon-list {
            height: auto;
            padding: 12px 10px;
          }
          .c-icon-list__list_wrapper {
            flex-wrap: wrap;
            gap: 15px;
            justify-content: center;
            padding: 0;
          }
          .v-bar { display: none; }
          .c-icon { min-width: 70px; }
        }
      `}</style>

      <div className="c-icon-list">
        <div className="c-icon-list__list_wrapper">
          {visibleItems.map((item, index) => (
            <React.Fragment key={item.to}>
              {index > 0 && <div className="v-bar"></div>}
              <Link to={item.to} className="c-icon">
                <i className={`${item.icon} tab-icon`}></i>
                <span>{item.label}</span>
              </Link>
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default NavStrip;